<script setup lang="ts">
/**
 * /tailor-resume-to-job — the tailoring tool (MarketingTailorTool) and the
 * page for the editor's "Tailor to a job" section, written for what people
 * search: "tailor resume to job description", "resume keywords from job
 * posting", "match resume to job".
 */
const { t } = useI18n()
const { faqPageNode } = useJsonLd()

definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/zivotopis-na-miru-inzeratu', de: '/lebenslauf-anpassen', pl: '/cv-dopasowane-do-oferty' } })

/** Answered in prose on the page, and mirrored into FAQPage structured data. */
const FAQ_IDS = ['what', 'invent', 'every', 'keywords', 'copies', 'free'] as const

const faqItems = computed(() =>
  FAQ_IDS.map(id => ({
    id,
    question: t(`tailorPage.faq.${id}.q`),
    answer: t(`tailorPage.faq.${id}.a`),
  })),
)

const extraNodes = computed(() => [faqPageNode('/tailor-resume-to-job', faqItems.value)])
</script>

<template>
  <MarketingFeaturePage
    seo-key="tailorResume"
    path="/tailor-resume-to-job"
    :breadcrumb-title="t('tailorPage.heading')"
    :extra-nodes="extraNodes"
  >
    <!-- The tailoring itself: the CV, the posting, and the result to unlock -->
    <MarketingTailorTool />

    <!-- How it looks in the editor, before the explanation of it -->
    <MarketingFeatureVideo video="tailor" />

    <MarketingTailorGuide />

    <!-- English only: tailoring for UK public-sector jobs happens in the statements -->
    <MarketingUkToolsNote
      text="For Civil Service and NHS jobs, tailoring happens in the statements: each criterion of the advert is scored on the evidence you write for it, in its own words."
    />

    <MarketingFaqSection
      :title="t('tailorPage.faq.title')"
      :items="faqItems"
      name="tailor-faq"
    />
  </MarketingFeaturePage>
</template>
